import { CoreIcon } from '../core-icon';
import accountSVG from '../../assets/icons/account.svg';
import type { IconProps } from '../core-icon';

export const AccountIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={accountSVG} {...props} />;
};
